import { List, Map } from 'immutable';

import { ATTRIBUTE } from '../../../../constants/attributes';

export function weight({ preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
      value: List([
        Map({
          combination: null,
          offeringId: null,
          value: Map({
            [ATTRIBUTE.WEIGHT]: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT]),
            [ATTRIBUTE.UNIT]: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.UNIT]),
          }),
        }),
      ]),
    }),
  };
}
